export default __webpack_public_path__ + "static/media/Team3.667f6a31.png";